import React, { Component } from 'react';

class BoldDecimalTextFormatter extends Component {
  render() {
    const { value } = this.props;
    return <span style={{ 'font-weight': 'bold' }}>{(value && parseFloat(value).toFixed(4)) || '-'}</span>;
  }
}

export default BoldDecimalTextFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/boldDecimalTextFormatter.jsx